// import React, { useEffect, useState } from "react";
// import { Col, Form, Modal, Row } from "react-bootstrap";
// import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
// import Select from 'react-select';
// import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, styled } from "@mui/material";
// import * as HeaderAuthentication from '../../HeaderAuthentication'
// import { useDispatch, useSelector } from "react-redux";
// import { loadSettingsRolesModulesSubmodulesData, postRolesDatas } from "../../../redux/action";
// import { ADDED_BY_ID } from "../../Constants";

// const enablingOptions = [
//     { value: 24, label: "Active" },
//     { value: 25, label: "Inactive" }
// ]
// const CustomCheckbox = styled(Checkbox)({
//     color: '#00c853', // Green checkmark color
//     '&.Mui-checked': {
//         color: '#00c853', // Green checkmark when checked
//     },
//     '& .MuiSvgIcon-root': {
//         fontSize: 20, // Size of the checkbox
//         backgroundColor: 'white', // White background
//         borderRadius: 4, // Optional: to make the checkbox corners slightly rounded
//     },
// });
// const AddRoles = (props) => {

//     let dispatch = useDispatch();

//     const getRoles = props.getRoles;
//     const roleId = props.roleId;
//     const getSingleRolesData = props.getSingleRolesData;
//     const { getModulesSubmodulesData } = useSelector((state) => state.data);

//     const [roleData, setRoleData] = useState({
//         RoleName: "",
//         Description: "",
//         StatusID: null,
//         AddedByID: ADDED_BY_ID
//     });

//     const [errors, setErrors] = useState({
//         RoleName: "",
//         Description: "",
//     });

//     // Initialize state for modules using getModulesSubmodulesData
//     const [modules, setModules] = useState([]);

//     useEffect(() => {
//         if (roleId && getSingleRolesData && getSingleRolesData.length > 0) {
//             // Initialize roleData
//             setRoleData({
//                 RoleID: roleId,
//                 RoleName: getSingleRolesData[0].RoleName,
//                 Description: getSingleRolesData[0].Description,
//                 StatusID: getSingleRolesData[0].StatusID,
//                 AddedByID: ADDED_BY_ID,
//             });

//             // Initialize modules and permissions
//             const updatedModules = getModulesSubmodulesData.map(module => {
//                 const rolePermissions = getSingleRolesData[0].RoleModulePermission.filter(permission => permission.ModuleID === module.ModulesID);

//                 // Map permissions for the module
//                 module.view = rolePermissions.some(p => p.View === "Y");
//                 module.create = rolePermissions.some(p => p.Create === "Y");
//                 module.update = rolePermissions.some(p => p.Update === "Y");
//                 module.financialApproval = rolePermissions.some(p => p.Financial === "Y");
//                 module.transactionalApproval = rolePermissions.some(p => p.Transactional === "Y");

//                 // Map permissions for submodules
//                 module.SubModules.forEach(subModule => {
//                     const subModulePermissions = rolePermissions.filter(p => p.SubModuleID === subModule.SubModulesID);
//                     subModule.view = subModulePermissions.some(p => p.View === "Y");
//                     subModule.create = subModulePermissions.some(p => p.Create === "Y");
//                     subModule.update = subModulePermissions.some(p => p.Update === "Y");
//                     subModule.financialApproval = subModulePermissions.some(p => p.Financial === "Y");
//                     subModule.transactionalApproval = subModulePermissions.some(p => p.Transactional === "Y");
//                 });

//                 return module;
//             });

//             setModules(updatedModules);
//         }
//     }, [roleId, getSingleRolesData]);

//     useEffect(() => {
//         dispatch(loadSettingsRolesModulesSubmodulesData())
//     }, []);

//     useEffect(() => {
//         if (getModulesSubmodulesData) {
//             setModules(getModulesSubmodulesData);
//         }
//     }, [getModulesSubmodulesData]);

//     // Handle checkbox change for both modules and submodules
//     const handleCheckboxChange = (moduleIndex, permission, isModule = true, subModuleIndex = null) => {
//         const updatedModules = [...modules];

//         if (isModule) {
//             // If it's a module, toggle the permission (view, create, etc.)
//             updatedModules[moduleIndex][permission] = !updatedModules[moduleIndex][permission];

//             // If the module permission is unchecked, disable all corresponding submodule permissions
//             if (!updatedModules[moduleIndex][permission]) {
//                 updatedModules[moduleIndex].SubModules.forEach(subModule => {
//                     subModule[permission] = false;
//                 });
//             }
//         } else {
//             // If it's a submodule, toggle the corresponding permission
//             updatedModules[moduleIndex].SubModules[subModuleIndex][permission] = !updatedModules[moduleIndex].SubModules[subModuleIndex][permission];
//         }

//         setModules(updatedModules);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setRoleData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));

//         // Clear the error message for the field the user is typing into
//         setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: "",
//         }));
//     };

//     // Handle Select dropdown change
//     const handleSelectChange = (selectedOption) => {
//         setRoleData((prevData) => ({
//             ...prevData,
//             StatusID: selectedOption ? selectedOption.value : null, // Update StatusID
//         }));
//     };

//     // Validate fields
//     const validateForm = () => {
//         let tempErrors = {};
//         let isValid = true;

//         if (!roleData.RoleName) {
//             tempErrors.RoleName = "Role Name is required";
//             isValid = false;
//         }

//         if (!roleData.Description) {
//             tempErrors.Description = "Role Description is required";
//             isValid = false;
//         }

//         setErrors(tempErrors);
//         return isValid;
//     };

//     const prepareRequestData = () => {
//         // Prepare the RoleModulePermission array
//         let roleModulePermissions = [];

//         // Iterate through each module
//         modules.forEach((module) => {
//             // Add module permission data, even if none of the permissions are selected
//             roleModulePermissions.push({
//                 ModuleID: module.ModulesID,
//                 View: module.view ? "Y" : "N",
//                 Create: module.create ? "Y" : "N",
//                 Update: module.update ? "Y" : "N",
//                 Financial: module.financialApproval ? "Y" : "N",
//                 Transactional: module.transactionalApproval ? "Y" : "N",
//             });

//             // Now iterate through submodules for this module
//             module.SubModules.forEach((subModule) => {
//                 // Add submodule permission data
//                 roleModulePermissions.push({
//                     ModuleID: module.ModulesID,
//                     SubModuleID: subModule.SubModulesID,
//                     View: subModule.view ? "Y" : "N",
//                     Create: subModule.create ? "Y" : "N",
//                     Update: subModule.update ? "Y" : "N",
//                     Financial: subModule.financialApproval ? "Y" : "N",
//                     Transactional: subModule.transactionalApproval ? "Y" : "N",
//                 });
//             });
//         });

//         // Return the data that will be sent to the server
//         return {
//             RoleID: roleId,
//             RoleName: roleData.RoleName,
//             Description: roleData.Description,
//             RoleModulePermission: roleModulePermissions,
//             AddedByID: roleData.AddedByID,
//             StatusID: roleData.StatusID
//         };
//     };

//     const AddRolesData = (e) => {
//         e.preventDefault();
//         if (validateForm()) {
//             const requestData = prepareRequestData();

//             // Prepare the POST request
//             let requestOption = {
//                 method: "POST",
//                 mode: "cors",
//                 headers: HeaderAuthentication.postExcomatixAuth,
//                 body: JSON.stringify(requestData),
//             };

//             // Dispatch the request to save data
//             dispatch(postRolesDatas(requestOption, props.handleCloseModal, getRoles, roleId));
//             console.log(requestData, 'requestData')
//         }
//     };

//     return (
//         <>
//             <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
//                 <Modal.Header closeButton>
//                     <Modal.Title>{roleId ? 'Edit Roles' : 'Add Roles'}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <Row className='customer-form-fields'>
//                         <Col>
//                             <Row>
//                                 <Col md={4}>
//                                     <div>
//                                         <label>Role Name <span className="required-asterisk">*</span></label>
//                                         <Form.Control
//                                             type="text"
//                                             name="RoleName"
//                                             value={roleData.RoleName}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>
//                                     {errors.RoleName && <small className="text-danger">{errors.RoleName}</small>}
//                                 </Col>
//                                 <Col md={8}>
//                                     <div>
//                                         <label>Role Description <span className="required-asterisk">*</span></label>
//                                         <Form.Control
//                                             type="text"
//                                             name="Description"
//                                             value={roleData.Description}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>
//                                     {errors.Description && <small className="text-danger">{errors.Description}</small>}
//                                 </Col>
//                             </Row>
//                             <Row className="className='add-role-table-div">
//                                 <h6 className="pt-3 fw-bold">Assign Permissions to Modules</h6>
//                                 <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container add-role-table-container' style={{ boxShadow: "none" }}>
//                                     <Table stickyHeader>
//                                         <TableHead>
//                                             <TableRow style={{ zIndex: "1" }}>
//                                                 <TableCell className='table-header-div'>Name</TableCell>
//                                                 <TableCell align="center" className='table-header-div'>View</TableCell>
//                                                 <TableCell align="center" className='table-header-div'>Create</TableCell>
//                                                 <TableCell align="center" className='table-header-div'>Update</TableCell>
//                                                 <TableCell align="center" className='table-header-div'>Financial Approval</TableCell>
//                                                 <TableCell align="center" className='table-header-div'>Transactional Approval</TableCell>
//                                             </TableRow>
//                                         </TableHead>
//                                         <TableBody>
//                                             {modules.map((module, index) => (
//                                                 <>
//                                                     <TableRow key={`module-${module.ModulesID}`}>
//                                                         <TableCell style={{ fontWeight: "600" }}>{module.Modules_Name}</TableCell>
//                                                         {/* Module Permission Checkboxes */}
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={module.view}
//                                                                 onChange={() => handleCheckboxChange(index, 'view')}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={module.create}
//                                                                 onChange={() => handleCheckboxChange(index, 'create')}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={module.update}
//                                                                 onChange={() => handleCheckboxChange(index, 'update')}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={module.financialApproval}
//                                                                 onChange={() => handleCheckboxChange(index, 'financialApproval')}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell align="center">
//                                                             <CustomCheckbox
//                                                                 checked={module.transactionalApproval}
//                                                                 onChange={() => handleCheckboxChange(index, 'transactionalApproval')}
//                                                             />
//                                                         </TableCell>
//                                                     </TableRow>

//                                                     {/* Loop through submodules */}
//                                                     {module.SubModules && module.SubModules.map((subModule, subIndex) => (
//                                                         <TableRow key={`submodule-${subModule.SubModulesID}`} style={{ backgroundColor: '#f4f4f4' }}>
//                                                             <TableCell>{`- ${subModule.SubModulesName}`}</TableCell>
//                                                             {/* Submodule Permission Checkboxes */}
//                                                             <TableCell align="center">
//                                                                 <CustomCheckbox
//                                                                     checked={subModule.view}
//                                                                     disabled={!module.view}  // Disable submodule view if module view is unchecked
//                                                                     onChange={() => handleCheckboxChange(index, 'view', false, subIndex)}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <CustomCheckbox
//                                                                     checked={subModule.create}
//                                                                     disabled={!module.create}  // Disable submodule create if module create is unchecked
//                                                                     onChange={() => handleCheckboxChange(index, 'create', false, subIndex)}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <CustomCheckbox
//                                                                     checked={subModule.update}
//                                                                     disabled={!module.update}  // Disable submodule update if module update is unchecked
//                                                                     onChange={() => handleCheckboxChange(index, 'update', false, subIndex)}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <CustomCheckbox
//                                                                     checked={subModule.financialApproval}
//                                                                     disabled={!module.financialApproval}  // Disable submodule financialApproval if module financialApproval is unchecked
//                                                                     onChange={() => handleCheckboxChange(index, 'financialApproval', false, subIndex)}
//                                                                 />
//                                                             </TableCell>
//                                                             <TableCell align="center">
//                                                                 <CustomCheckbox
//                                                                     checked={subModule.transactionalApproval}
//                                                                     disabled={!module.transactionalApproval}  // Disable submodule transactionalApproval if module transactionalApproval is unchecked
//                                                                     onChange={() => handleCheckboxChange(index, 'transactionalApproval', false, subIndex)}
//                                                                 />
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     ))}
//                                                 </>
//                                             ))}
//                                         </TableBody>
//                                     </Table>
//                                 </TableContainer>
//                             </Row>
//                             <Row>
//                                 {roleId && <Col md={4}>
//                                     <div>
//                                         <label>Active / Inactive</label>
//                                         <Select
//                                             className="react-select-container"
//                                             classNamePrefix="react-select"
//                                             options={enablingOptions}
//                                             placeholder="Select"
//                                             value={enablingOptions.find(option => option.value === roleData.StatusID)}
//                                             onChange={handleSelectChange}
//                                         />
//                                     </div>
//                                 </Col>}
//                             </Row>
//                         </Col>
//                     </Row>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
//                     <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddRolesData} />
//                 </Modal.Footer>
//             </Modal>
//         </>
//     );
// }

// export default AddRoles;




import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, styled } from "@mui/material";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch, useSelector } from "react-redux";
import { loadSettingsRolesModulesSubmodulesData, postRolesDatas } from "../../../redux/action";
import { ADDED_BY_ID } from "../../../Constants";

const enablingOptions = [
    { value: 24, label: "Active" },
    { value: 25, label: "Inactive" }
];

const CustomCheckbox = styled(Checkbox)({
    color: '#00c853', // Green checkmark color
    '&.Mui-checked': {
        color: '#00c853', // Green checkmark when checked
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20, // Size of the checkbox
        backgroundColor: 'white', // White background
        borderRadius: 4, // Optional: to make the checkbox corners slightly rounded
    },
});

const AddRoles = (props) => {
    let dispatch = useDispatch();

    const getRoles = props.getRoles;
    const roleId = props.roleId;
    const getSingleRolesData = props.getSingleRolesData;
    const { getModulesSubmodulesData } = useSelector((state) => state.data);

    const [roleData, setRoleData] = useState({
        RoleName: "",
        Description: "",
        StatusID: null,
        AddedByID: ADDED_BY_ID
    });

    const [errors, setErrors] = useState({
        RoleName: "",
        Description: "",
    });

    const [modules, setModules] = useState([]);

    useEffect(() => {
        if (roleId && getSingleRolesData && getSingleRolesData.length > 0) {
            // Initialize roleData
            setRoleData({
                RoleID: roleId,
                RoleName: getSingleRolesData[0].RoleName,
                Description: getSingleRolesData[0].Description,
                StatusID: getSingleRolesData[0].StatusID,
                AddedByID: ADDED_BY_ID,
            });

            // Initialize modules and permissions
            const updatedModules = getModulesSubmodulesData.map(module => {
                const rolePermissions = getSingleRolesData[0].RoleModulePermission.filter(permission => permission.ModuleID === module.ModulesID);

                // Map permissions for the module, defaulting to false if not defined
                module.view = rolePermissions.some(p => p.View === "Y") || false;
                module.create = rolePermissions.some(p => p.Create === "Y") || false;
                module.update = rolePermissions.some(p => p.Update === "Y") || false;
                module.financialApproval = rolePermissions.some(p => p.Financial === "Y") || false;
                module.transactionalApproval = rolePermissions.some(p => p.Transactional === "Y") || false;

                // Map permissions for submodules, defaulting to false if not defined
                module.SubModules.forEach(subModule => {
                    const subModulePermissions = rolePermissions.filter(p => p.SubModuleID === subModule.SubModulesID);
                    subModule.view = subModulePermissions.some(p => p.View === "Y") || false;
                    subModule.create = subModulePermissions.some(p => p.Create === "Y") || false;
                    subModule.update = subModulePermissions.some(p => p.Update === "Y") || false;
                    subModule.financialApproval = subModulePermissions.some(p => p.Financial === "Y") || false;
                    subModule.transactionalApproval = subModulePermissions.some(p => p.Transactional === "Y") || false;
                });

                return module;
            });

            setModules(updatedModules);
        }
    }, [roleId, getSingleRolesData, getModulesSubmodulesData]);

    useEffect(() => {
        dispatch(loadSettingsRolesModulesSubmodulesData());
    }, [dispatch]);

    useEffect(() => {
        if (getModulesSubmodulesData) {
            setModules(getModulesSubmodulesData);
        }
    }, [getModulesSubmodulesData]);

    // Handle checkbox change for both modules and submodules
    // const handleCheckboxChange = (moduleIndex, permission, isModule = true, subModuleIndex = null) => {
    //     const updatedModules = [...modules];

    //     if (isModule) {
    //         // Ensure the permission is set to false if not present
    //         updatedModules[moduleIndex][permission] = updatedModules[moduleIndex][permission] || false;

    //         // If it's a module, toggle the permission (view, create, etc.)
    //         updatedModules[moduleIndex][permission] = !updatedModules[moduleIndex][permission];

    //         // If the module permission is unchecked, disable all corresponding submodule permissions
    //         if (!updatedModules[moduleIndex][permission]) {
    //             updatedModules[moduleIndex].SubModules.forEach(subModule => {
    //                 subModule[permission] = false;
    //             });
    //         }
    //     } else {
    //         // Ensure submodule permission is controlled
    //         updatedModules[moduleIndex].SubModules[subModuleIndex][permission] = updatedModules[moduleIndex].SubModules[subModuleIndex][permission] || false;

    //         // If it's a submodule, toggle the corresponding permission
    //         updatedModules[moduleIndex].SubModules[subModuleIndex][permission] = !updatedModules[moduleIndex].SubModules[subModuleIndex][permission];
    //     }

    //     setModules(updatedModules);
    // };

    const handleCheckboxChange = (moduleIndex, permission, isModule = true, subModuleIndex = null) => {
        const updatedModules = [...modules];

        if (isModule) {
            // Toggle module permission
            updatedModules[moduleIndex][permission] = !updatedModules[moduleIndex][permission];

            // If the module is checked, check all submodules
            updatedModules[moduleIndex].SubModules.forEach(subModule => {
                subModule[permission] = updatedModules[moduleIndex][permission];
            });
        } else {
            // Toggle submodule permission
            updatedModules[moduleIndex].SubModules[subModuleIndex][permission] =
                !updatedModules[moduleIndex].SubModules[subModuleIndex][permission];

            // If all submodules are unchecked, uncheck the module permission
            const allUnchecked = updatedModules[moduleIndex].SubModules.every(sub => !sub[permission]);
            updatedModules[moduleIndex][permission] = !allUnchecked;
        }

        setModules(updatedModules);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setRoleData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handleSelectChange = (selectedOption) => {
        setRoleData((prevData) => ({
            ...prevData,
            StatusID: selectedOption ? selectedOption.value : null,
        }));
    };

    const validateForm = () => {
        let tempErrors = {};
        let isValid = true;

        if (!roleData.RoleName) {
            tempErrors.RoleName = "Role Name is required";
            isValid = false;
        }

        if (!roleData.Description) {
            tempErrors.Description = "Role Description is required";
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };

    const prepareRequestData = () => {
        const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));

        let CustomerID = null;
        if (signInDetails?.[0]?.SignInType === "SuperAdmin" ||
            signInDetails?.[0]?.SignInType === "ClientAdmin" ||
            signInDetails?.[0]?.SignInType === "User") {
            CustomerID = signInDetails?.[0]?.CompanyID;
        }
        let roleModulePermissions = [];

        modules.forEach((module) => {
            roleModulePermissions.push({
                ModuleID: module.ModulesID,
                View: module.view ? "Y" : "N",
                Create: module.create ? "Y" : "N",
                Update: module.update ? "Y" : "N",
                Financial: module.financialApproval ? "Y" : "N",
                Transactional: module.transactionalApproval ? "Y" : "N",
            });

            module.SubModules.forEach((subModule) => {
                roleModulePermissions.push({
                    ModuleID: module.ModulesID,
                    SubModuleID: subModule.SubModulesID,
                    View: subModule.view ? "Y" : "N",
                    Create: subModule.create ? "Y" : "N",
                    Update: subModule.update ? "Y" : "N",
                    Financial: subModule.financialApproval ? "Y" : "N",
                    Transactional: subModule.transactionalApproval ? "Y" : "N",
                });
            });
        });

        return {
            RoleID: roleId,
            RoleName: roleData.RoleName,
            Description: roleData.Description,
            RoleModulePermission: roleModulePermissions,
            AddedByID: roleData.AddedByID,
            StatusID: roleData.StatusID,
            CompanyID: CustomerID,  // Adding CompanyID here
        };
    };

    const AddRolesData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestData = prepareRequestData();

            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(requestData),
            };

            dispatch(postRolesDatas(requestOption, props.handleCloseModal, getRoles, roleId));
            console.log(requestData, 'requestData');
        }
    };

    return (
        <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>{roleId ? 'Edit Roles' : 'Add Roles'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={4}>
                                <div>
                                    <label>Role Name <span className="required-asterisk">*</span></label>
                                    <Form.Control
                                        type="text"
                                        name="RoleName"
                                        value={roleData.RoleName}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                {errors.RoleName && <small className="text-danger">{errors.RoleName}</small>}
                            </Col>
                            <Col md={8}>
                                <div>
                                    <label>Role Description <span className="required-asterisk">*</span></label>
                                    <Form.Control
                                        type="text"
                                        name="Description"
                                        value={roleData.Description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                {errors.Description && <small className="text-danger">{errors.Description}</small>}
                            </Col>
                        </Row>
                        <Row className="className='add-role-table-div">
                            <h6 className="pt-3 fw-bold">Assign Permissions to Modules</h6>
                            <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container add-role-table-container' style={{ boxShadow: "none" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow style={{ zIndex: "1" }}>
                                            <TableCell className='table-header-div'>Name</TableCell>
                                            <TableCell align="center" className='table-header-div'>View</TableCell>
                                            <TableCell align="center" className='table-header-div'>Create</TableCell>
                                            <TableCell align="center" className='table-header-div'>Update</TableCell>
                                            <TableCell align="center" className='table-header-div'>Financial Approval</TableCell>
                                            <TableCell align="center" className='table-header-div'>Transactional Approval</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {modules.map((module, index) => (
                                            <>
                                                <TableRow key={`module-${module.ModulesID}`}>
                                                    <TableCell style={{ fontWeight: "600" }}>{module.Modules_Name}</TableCell>
                                                    <TableCell align="center">
                                                        <CustomCheckbox
                                                            checked={module.view}
                                                            onChange={() => handleCheckboxChange(index, 'view')}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <CustomCheckbox
                                                            checked={module.create}
                                                            onChange={() => handleCheckboxChange(index, 'create')}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <CustomCheckbox
                                                            checked={module.update}
                                                            onChange={() => handleCheckboxChange(index, 'update')}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <CustomCheckbox
                                                            checked={module.financialApproval}
                                                            onChange={() => handleCheckboxChange(index, 'financialApproval')}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <CustomCheckbox
                                                            checked={module.transactionalApproval}
                                                            onChange={() => handleCheckboxChange(index, 'transactionalApproval')}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                {module.SubModules && module.SubModules.map((subModule, subModuleIndex) => (
                                                    <TableRow key={`submodule-${subModule.SubModulesID}`}>
                                                        <TableCell className="submodule">{`- ${subModule.SubModulesName}`}</TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                checked={subModule.view}
                                                                disabled={!module.view} // Disable submodule view if module view is unchecked
                                                                onChange={() => handleCheckboxChange(index, 'view', false, subModuleIndex)}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                checked={subModule.create}
                                                                disabled={!module.create}  // Disable submodule create if module create is unchecked
                                                                onChange={() => handleCheckboxChange(index, 'create', false, subModuleIndex)}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                checked={subModule.update}
                                                                disabled={!module.update}  // Disable submodule update if module update is unchecked
                                                                onChange={() => handleCheckboxChange(index, 'update', false, subModuleIndex)}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                checked={subModule.financialApproval}
                                                                disabled={!module.financialApproval}  // Disable submodule financialApproval if module financialApproval is unchecked
                                                                onChange={() => handleCheckboxChange(index, 'financialApproval', false, subModuleIndex)}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                checked={subModule.transactionalApproval}
                                                                disabled={!module.transactionalApproval}  // Disable submodule transactionalApproval if module transactionalApproval is unchecked
                                                                onChange={() => handleCheckboxChange(index, 'transactionalApproval', false, subModuleIndex)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddRolesData} />
            </Modal.Footer>
        </Modal>
    );
}

export default AddRoles;

